import { localize } from 'vee-validate';
import locale from 'vee-validate/dist/locale/pt_BR.json';
import custom from './custom.json';

const localeReady = {};
const { messages } = locale;

Object.assign(localeReady, locale, custom);
Object.assign(messages, custom.messages);

localeReady.messages = messages;

localize('pt_BR', localeReady);
